module.exports = __webpack_public_path__ + "static/media/plus-icon.f6c7a981.svg";